<template>
  <div>
    <div class="el-tree-node__content">
      <span class="orgName">{{ $t(`common.orgList`) }}:</span>
      <span class="addBtn" v-if="buttonAuth.indexOf('org_add') > -1&&$store.state.login.user.org=='root'">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$t(`common.addOrg`)"
          placement="top"
        >
          <i style="" class="el-icon-plus" @click="add('root')" />
        </el-tooltip>
      </span>
    </div>
    <el-tree
      :data="treeData"
      :props="defaultProps"
      node-key="id"
      default-expand-all
      ref="tree"
      highlight-current
      :expand-on-click-node="false"
      @node-click="nodeClick"
    >
      <template slot-scope="{ data }">
        <span>
          <span>
            <i
              v-if="data.type == 'DEPARTMENT'"
              class="iconfont icon-bumen treeIcon"
            ></i>
            <i
              v-if="data.type == 'ORG'"
              class="iconfont icon-jigou treeIcon"
            ></i>
            <i
              v-if="data.type == 'POSITION'"
              class="iconfont icon-gangwei treeIcon"
            ></i>
            <span class="treeText">{{ data.label }}</span>
          </span>
          <span class="authfr" style="position:absolute;right:0;">
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t(`common.connectResourceGroup`)"
              placement="top"
            >
              <i
                v-if="
                  data.type == 'POSITION' &&
                  buttonAuth.indexOf('position_relgroup_add') > -1
                "
                style="margin: 15px"
                class="el-icon-paperclip"
                @click.stop="connect(data)"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t(`common.addOrgorPo`)"
              placement="top"
            >
              <i
                v-if="
                  (data.type == 'ORG' || data.type == 'DEPARTMENT') &&
                  (buttonAuth.indexOf('position_add') > -1 ||
                    buttonAuth.indexOf('org_add') > -1)
                "
                style="margin: 15px"
                class="el-icon-plus"
                @click.stop="append(data)"
              />
            </el-tooltip>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="$t(`common.toTop`)"
              placement="top"
            >
              <i
                style="transform: rotate(180deg); margin: 3px"
                class="el-icon-download"
                @click.stop="toTop(data)"
                v-if="
                  buttonAuth.indexOf('position_edit') > -1 ||
                  buttonAuth.indexOf('org_edit') > -1
                "
              />
            </el-tooltip> -->
          </span>
        </span>
      </template>
    </el-tree>
  </div>
</template>

<script>
// let id = 1000;
export default {
  props: ["treeData", "defaultProps"],
  computed: {
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth||[];
    },
  },
  watch:{
    treeData(val,oldVal){
      if(val.length>0){
        if(oldVal.length==0){
          this.$nextTick(function () {
            console.log('treeData',this.treeData[0].id)
            let currentId = this.treeData[0].id
            this.$refs.tree.setCurrentKey(currentId)
          })
          this.nodeClick(this.treeData[0]) 
        }
      }
    }
  },
  methods: {
    append(data) {
      this.$emit("setCurrentNode", data);
      //弹出新增的抽屉
      this.$emit("addOrg", "addChild"); //新增部门或者岗位
      // const newChild = { id: id++, label: "testtest", children: [] };
      // if (!data.children) {
      //   this.$set(data, "children", []);
      // }
      // data.children.push(newChild);
    },

    toTop(node, data) {
      console.log(node);
      console.log(data);
      //与后端交互，然后重新获取树形图数据
      this.$emit("getTreeData");
      //   const parent = node.parent;
      //   const children = parent.data.children || parent.data;
      //   const index = children.findIndex((d) => d.id === data.id);
      //   children.splice(index, 1);
    },
    add(data) {
      //弹出新增的抽屉
      this.$emit("editCurrentNode", data);
      this.$emit("addOrg", "addRoot");
    },
    nodeClick(data, node, obj) {
      console.log(data);
      console.log(node);
      console.log(obj);
      this.$emit("setCurrentNode", data);
    },
    connect(data) {
      //岗位关联资源分组
      this.$emit("editCurrentNode", data, "connect");
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-tree-node__content {
  display: block !important;
  height: 55px !important;
  line-height: 55px !important;
  // font-family: PingFangSC-Regular !important;
  font-size: 14px !important;
  color: #343c6a !important;
  font-weight: 400 !important;
}
.treeText {
  width: 190px;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
/* .authfr { */
/* margin-right: 10px; */
/* } */
.addBtn {
  background-color: #343c6a;
  color: white;
  border-radius: 14px;
  font-size: 14px;
  width: 18px;
  height: 18px;
  display: inline-block;
  line-height: 18px;
  text-align: center;
  cursor: pointer;
  float: right;
  margin-right: 20px;
  margin-top: 20px;
}
.orgName {
  margin-left: 20px;
  font-weight: 600;
}
::v-deep .el-tree-node__expand-icon,
.el-icon-caret-right:before {
  transform: translateY(-21px) !important;
}
::v-deep .el-tree-node__expand-icon.expanded {
  transform: translateY(-21px) rotate(90deg) !important;
}
.treeIcon {
  display: inline-block;
  height: 20px;
  width: 25px;
  line-height: 20px;
  transform: translate(0px, -22px);
}
</style>
